import React from 'react';
import OpportunityListPage from './OpportunityListPage';

export default function JobOpeningsPage() {
  return <OpportunityListPage opportunityType="Job_Opening" />;
}